<template>
  <q-btn
    :class="classes"
    class="san-button"
    no-caps
    rounded
    :style="style"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>
  </q-btn>
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import { useButton } from '@/composables'

defineOptions({ name: 'SanButton' })
const props = defineProps({
  fullwidth: { type: Boolean, default: false }
})

const $attrs = useAttrs()
const { style } = useButton() // eslint-disable-line

const classes = computed(() => {
  const classes = [`size-${$attrs.size ?? 'md'}`]
  if (props.fullwidth) classes.push('full-width')
  return classes
})
</script>
